// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__k4ZCc","item":"Pagination_item__dpFHM","active":"Pagination_active__SPKjd","disabled":"Pagination_disabled__K2otb"};